module.exports = __webpack_public_path__ + "static/logo-efd0b100c2e15c4acfa295fcb0340ddc.jpg";